// crm namespace — Clients list filter bar.
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "filters.all": "Tous",
    "filters.any": "Toutes",
    "filters.anything": "tout",
    "filters.bought": "Achat : {kind} · {range}",
    "filters.clear": "Effacer les filtres",
    "filters.consent": "Consentement",
    "filters.created": "Créés · {range}",
    "filters.label": "Filtres",
    "filters.lastActivity": "Dernière activité",
    "filters.packStatus": "État du forfait",
    "filters.remove": "Retirer le filtre {label}",
    "filters.set": "{label} : {value}",
    "filters.source": "Source",
    "filters.stage": "Étape",
    "filters.tags": "Étiquettes",
  },
  en: {
    "filters.all": "All",
    "filters.any": "Any",
    "filters.anything": "anything",
    "filters.bought": "Bought: {kind} · {range}",
    "filters.clear": "Clear filters",
    "filters.consent": "Consent",
    "filters.created": "Created · {range}",
    "filters.label": "Filters",
    "filters.lastActivity": "Last activity",
    "filters.packStatus": "Pack status",
    "filters.remove": "Remove the filter {label}",
    "filters.set": "{label}: {value}",
    "filters.source": "Source",
    "filters.stage": "Stage",
    "filters.tags": "Tags",
  },
  es: {
    "filters.all": "Todos",
    "filters.any": "Cualquiera",
    "filters.anything": "cualquier cosa",
    "filters.bought": "Compra: {kind} · {range}",
    "filters.clear": "Borrar filtros",
    "filters.consent": "Consentimiento",
    "filters.created": "Creados · {range}",
    "filters.label": "Filtros",
    "filters.lastActivity": "Última actividad",
    "filters.packStatus": "Estado del bono",
    "filters.remove": "Quitar el filtro {label}",
    "filters.set": "{label}: {value}",
    "filters.source": "Origen",
    "filters.stage": "Etapa",
    "filters.tags": "Etiquetas",
  },
};
